import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { navigateTo } from '@app-store'
import { useAppDispatch, useAppSelector } from '../../utils/agent.store'

const NavigationListener: React.FC = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const navigationPath = useAppSelector((state) => state?.navigation?.path)

  useEffect(() => {
    if (navigationPath) {
      navigate(navigationPath)
      dispatch(navigateTo(null)) // Reset navigation state after navigating
    }
  }, [navigationPath, navigate, dispatch])

  return null // No UI
}

export default NavigationListener
